import React, { useEffect } from 'react';
import classes from "./styles/contact.module.css";

const Contact = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
}, []);


  return (
    <div>
      <div className={classes.bookingCon}>
        <h2>Schedule a quick call with us <br/> to learn more!</h2>
        <div className={classes.calendlyCon}>
        <div className={`${classes.calendar} calendly-inline-widget`} data-url="https://calendly.com/getfitwithsusmitatoday/30min?background_color=0b4650&text_color=ffffff&primary_color=e6ff2b" style={{ minWidth: '320px', height: '700px' }}></div>
        </div>
      </div>
    </div>
  )
}

export default Contact;
